import { FC } from 'react';
import { Typography as MuiTypography } from '@mui/material';

import { TypographyProps } from './types';

const Typography: FC<React.PropsWithChildren<TypographyProps>> = ({
  children,
  color,
  component,
  maxWidth,
  noWrap,
  variant,
}) => {
  return (
    <MuiTypography
      variant={variant}
      color={color}
      component={component ?? 'span'}
      noWrap={noWrap}
      maxWidth={maxWidth ?? 'none'}
    >
      {children}
    </MuiTypography>
  );
};

export default Typography;
